module.exports = __webpack_public_path__ + "img/new_index_banner3.9f0b8db8.jpg";